import { useTranslations } from '@/lib/i18n';
import { Button, TextInput } from '@mantine/core';
import { useForm, zodResolver } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { z } from 'zod';
import authClient from '../../lib/auth-client';

const formSchema = z.object({
  email: z.string().email({ message: 'login_view.enter_your_email' }),
  code: z.string({ invalid_type_error: 'login_view.enter_login_code' }).min(6, 'login_view.must_be_6_digits')
});

type FormSchemaType = z.infer<typeof formSchema>;

function LoginForm({ email }: { email: string }) {
  const t = useTranslations();
  const form = useForm<FormSchemaType>({
    mode: 'uncontrolled',
    initialValues: {
      code: '',
      email
    },
    validate: zodResolver(formSchema)
  });

  const handleFormSubmit = form.onSubmit(async (values) => {
    authClient
      .signIn(values.email, values.code)
      .then(() => {
        location.href = '/';
      })
      .catch((error) =>
        notifications.show({
          title: 'Error',
          message: error?.message,
          color: 'red'
        })
      );
  });

  return (
    <form onSubmit={handleFormSubmit}>
      <TextInput
        required
        label={t('login_view.email')}
        disabled
        placeholder={t('login_view.email')}
        {...form.getInputProps('email')}
        error={t((form.errors.email as string) || '')}
      />
      <TextInput
        required
        label={t('login_view.code')}
        placeholder={t('login_view.code')}
        mt="md"
        {...form.getInputProps('code')}
        error={t((form.errors.code as string) || '')}
      />
      <Button type="submit" fullWidth mt="xl">
        {t('login_view.login')}
      </Button>
    </form>
  );
}

export default LoginForm;
